import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Per-contract render metadata exposed to templates.
 *
 * Distinct from `OwnerBrandingProvider` because branding is app-level
 * (owner + tenant) but this stuff is per-contract — populated by the
 * editor preview and by the SSR render path with values for the specific
 * contract being rendered.
 *
 * For now only carries `avtalNr` (currently the contract row UUID; soon a
 * user-editable custom field — see ContractEditorPage / contracts-render).
 */
import { createContext, useContext } from 'react';
/**
 * Resolve a contract's object identifier from its template's titleSuffix
 * convention. Tries `titleSuffixKey` first, then `fallbackKey` — the
 * second arg lets a template prefer its primary id (e.g. landlord's
 * lgh.nr.) while still surfacing an identifier when only a sibling
 * (e.g. officiellt lägenhetsnr.) was captured. Returns null when none
 * resolves — same "graceful degradation" semantics as the auto-derived
 * contract title.
 *
 * Overload kept so existing single-arg callers in non-template code
 * don't need to thread a fallback they don't have.
 */
export function resolveObjektNr(titleSuffixKey, values, fallbackKey) {
    if (!values)
        return null;
    const primary = readStringValue(values, titleSuffixKey);
    if (primary !== null)
        return primary;
    return readStringValue(values, fallbackKey);
}
function readStringValue(values, key) {
    if (!key)
        return null;
    const raw = values[key];
    if (typeof raw !== 'string')
        return null;
    const trimmed = raw.trim();
    return trimmed.length > 0 ? trimmed : null;
}
const DocumentMetaCtx = createContext(null);
export function DocumentMetaProvider(props) {
    return (_jsx(DocumentMetaCtx.Provider, { value: props.value, children: props.children }));
}
export function useDocumentMeta() {
    return useContext(DocumentMetaCtx);
}
//# sourceMappingURL=document-meta.js.map